import React, { useRef, useState } from 'react';

// ---------------------------------------------------------------------------
// Protocol icons
// ---------------------------------------------------------------------------

const LoRaIcon = () => (
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#lora-clip)">
            <path d="M10.3184 8.14219C9.74182 8.14219 9.3062 8.34718 9.01152 8.76999C8.74246 9.15436 8.60152 9.66685 8.60152 10.3203C8.60152 10.9737 8.74246 11.4862 9.01152 11.8706C9.3062 12.2934 9.74182 12.4984 10.3184 12.4984C11.4715 12.4984 12.0352 11.7424 12.0352 10.2306C12.0352 9.6156 11.8943 9.11592 11.6252 8.74436C11.3305 8.34718 10.8949 8.14219 10.3184 8.14219ZM10.3184 6.52783C11.4715 6.52783 12.394 6.86095 13.0986 7.52719C13.8033 8.19343 14.1493 9.12873 14.1493 10.3203C14.1493 11.5118 13.8033 12.4471 13.0986 13.1134C12.394 13.7796 11.4715 14.1127 10.3184 14.1127C9.16526 14.1127 8.24278 13.7796 7.5381 13.1134C6.83342 12.4471 6.48749 11.5118 6.48749 10.3203C6.48749 9.12873 6.83342 8.19343 7.5381 7.52719C8.25559 6.86095 9.17808 6.52783 10.3184 6.52783Z" fill="black"/>
            <path d="M10.2545 5.09298C11.3051 5.09298 12.2917 5.40047 13.1116 5.93859L13.5216 5.34922C12.5735 4.73423 11.4589 4.37549 10.2545 4.37549C9.10138 4.37549 8.02515 4.70861 7.10266 5.27235L7.51266 5.86172C8.31983 5.36204 9.25513 5.09298 10.2545 5.09298Z" fill="#009FE3"/>
            <path d="M5.82123 3.42746L6.37216 4.20901C7.49964 3.49152 8.83212 3.08153 10.2543 3.08153C11.7405 3.08153 13.1114 3.52996 14.2646 4.28589L14.8155 3.50434C13.5086 2.6331 11.9327 2.12061 10.2543 2.12061C8.62713 2.12061 7.10246 2.60747 5.82123 3.42746Z" fill="#009FE3"/>
            <path d="M10.254 1.03151C12.1759 1.03151 13.9568 1.60806 15.4558 2.60742L16.1477 1.62087C14.4693 0.480577 12.4321 -0.172852 10.254 -0.172852C8.13998 -0.172852 6.15407 0.454953 4.50128 1.53119L5.19315 2.51774C6.65375 1.58244 8.38342 1.03151 10.254 1.03151Z" fill="#009FE3"/>
            <path d="M10.395 15.5736C9.34434 15.5736 8.35779 15.2661 7.5378 14.728L7.12781 15.3174C8.07592 15.9324 9.19059 16.2911 10.4078 16.2911C11.5609 16.2911 12.6371 15.958 13.5596 15.3943L13.1496 14.8049C12.3296 15.3046 11.3943 15.5736 10.395 15.5736Z" fill="#009FE3"/>
            <path d="M14.828 17.2393L14.2771 16.4577C13.1496 17.1752 11.8171 17.5852 10.3949 17.5852C8.9087 17.5852 7.53778 17.1368 6.38467 16.3809L5.83374 17.1624C7.1406 18.0336 8.7037 18.5461 10.3949 18.5461C12.0221 18.5461 13.5468 18.0593 14.828 17.2393Z" fill="#009FE3"/>
            <path d="M10.395 19.635C8.4731 19.635 6.69219 19.0584 5.19315 18.0591L4.50128 19.0456C6.1797 20.1731 8.21686 20.8394 10.395 20.8394C12.509 20.8394 14.4949 20.2116 16.1477 19.1353L15.4558 18.1488C13.9952 19.0841 12.2527 19.635 10.395 19.635Z" fill="#009FE3"/>
        </g>
        <defs>
            <clipPath id="lora-clip"><rect width="20.4641" height="21.3539" fill="white"/></clipPath>
        </defs>
    </svg>
);

const ZigbeeIcon = () => (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#zigbee-clip)">
            <path d="M14.9701 3.09204C17.4232 3.75294 17.5753 4.78166 17.9191 5.7869C16.4644 7.29448 7.12685 16.9229 7.12685 16.9229C7.12685 16.9229 12.9463 17.5513 19.6653 16.3875C19.6648 16.403 19.6642 16.4131 19.6637 16.4281C20.7287 14.7667 21.3539 12.7963 21.3539 10.6769C21.3539 4.78006 16.5738 0 10.6769 0C7.66924 0 4.95677 1.24813 3.01624 3.24952C6.13337 2.73543 12.2198 2.35053 14.9701 3.09204Z" fill="#EC0B43"/>
            <path d="M5.72497 17.7692C4.66689 17.584 3.47641 16.6316 3.21216 14.9388C3.97929 14.2773 13.8859 3.99119 13.8859 3.99119C10.1447 3.76484 6.10827 3.74295 2.01474 4.45243C0.751656 6.20612 0 8.35165 0 10.6771C0 16.574 4.78006 21.354 10.6769 21.354C13.9724 21.354 16.9171 19.8592 18.8757 17.513C16.8087 17.7933 10.2803 18.5615 5.72497 17.7692Z" fill="#EC0B43"/>
        </g>
        <defs>
            <clipPath id="zigbee-clip"><rect width="21.3539" height="21.3539" fill="white"/></clipPath>
        </defs>
    </svg>
);

// Map protocol key → { Icon, label }
const PROTOCOL_META = {
    lora:   { Icon: LoRaIcon,   label: 'LoRa'   },
    zigbee: { Icon: ZigbeeIcon, label: 'Zigbee' },
};

// ---------------------------------------------------------------------------
// Protocol popover — breakdown loaded lazily from
// GET /enterprises/{id}/protocol-locations on first hover.
// Shape: [{ protocol, count, total, locations: string[] }]
// ---------------------------------------------------------------------------

const ProtocolPopover = ({ breakdown }) => (
    <div className="enterprise-card__protocol-popover">
        <div className="enterprise-card__protocol-popover-title">Device Types</div>
        <div className="enterprise-card__protocol-popover-cols">
            {breakdown.map(item => {
                const meta = PROTOCOL_META[item.protocol];
                if (!meta) return null;
                return (
                    <div key={item.protocol} className="enterprise-card__protocol-popover-col">
                        <div className="enterprise-card__protocol-popover-header">
                            <meta.Icon />
                            <span className="enterprise-card__protocol-popover-count">
                                {item.count}/{item.total}
                            </span>
                        </div>
                        {item.locations.map(loc => (
                            <div key={loc} className="enterprise-card__protocol-popover-location">{loc}</div>
                        ))}
                    </div>
                );
            })}
        </div>
    </div>
);

const TIMEFRAME_OPTIONS = [
    { value: 12,   label: 'Last 12 hours' },
    { value: 24,   label: 'Last 24 hours' },
    { value: 72,   label: 'Last 72 hours' },
    { value: 168,  label: 'Last 7 days' },
    { value: 720,  label: 'Last 30 days' },
    { value: null, label: 'All Time' },
];

const SORT_OPTIONS = [
    { value: 'name',               label: 'Alphabetical A-Z' },
    { value: 'devicesOffline',     label: 'Devices Offline' },
    { value: 'criticalAlertEvents',label: 'Critical Alert Events' },
    { value: 'percentOffline',     label: 'Percent Offline' },
];

const Metric = ({ value, total, label }) => {
    const isAlert = value > 0;
    return (
        <div className="enterprise-card__metric">
            <div className={`enterprise-card__metric-value ${isAlert ? 'is-alert' : ''}`}>
                {value}/{total}
            </div>
            <div className={`enterprise-card__metric-label ${isAlert ? 'is-alert' : ''}`}>{label}</div>
        </div>
    );
};

const EnterpriseCard = ({ card, timeframe, isPinned, onPinToggle, onCardClick, protocolBreakdown, onProtocolHover }) => {
    const {
        enterpriseId, enterpriseName,
        locationsTotal, locationsWithCriticalEvents, locationsOffline,
        gatewaysOffline, gatewaysTotal,
        sensorsOffline, sensorsOfflineInWindow, sensorsTotal,
        locationsWithAlertsDisabled,
        protocolTypes = [],
    } = card;

    const breakdown = protocolBreakdown || [];
    const [showProtocolPopover, setShowProtocolPopover] = useState(false);
    const hideTimer = useRef(null);

    const handleProtocolEnter = () => {
        clearTimeout(hideTimer.current);
        setShowProtocolPopover(true);
        if (onProtocolHover) onProtocolHover(enterpriseId);
    };
    const handleProtocolLeave = () => {
        hideTimer.current = setTimeout(() => setShowProtocolPopover(false), 150);
    };

    return (
        <div className="enterprise-card">
            <div className="enterprise-card__header">
                <span
                    className="enterprise-card__name"
                    onClick={() => onCardClick && onCardClick(enterpriseId)}
                >
                    {enterpriseName}
                </span>
                <button
                    className={`enterprise-card__pin ${isPinned ? 'is-pinned' : ''}`}
                    onClick={() => onPinToggle(enterpriseId)}
                    title={isPinned ? 'Unpin' : 'Pin'}
                >
                    <svg width="25" height="29" viewBox="0 0 25 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.4956 19.2129L12.4956 27.5263" stroke="#556484" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M16.7383 7.19231C16.8312 7.19232 16.9231 7.17404 17.0089 7.13851C17.0947 7.10298 17.1727 7.05089 17.2384 6.98523C17.304 6.91957 17.3561 6.84161 17.3916 6.75581C17.4272 6.67002 17.4454 6.57806 17.4454 6.4852L17.4454 5.36373C17.4454 5.09856 17.34 4.84427 17.1525 4.65677C16.965 4.46927 16.7108 4.36392 16.4456 4.36388L8.54579 4.36388C8.28063 4.36392 8.02633 4.46927 7.83883 4.65677C7.65133 4.84427 7.54598 5.09856 7.54594 5.36373L7.54594 6.4852C7.54593 6.57806 7.56421 6.67002 7.59974 6.75581C7.63527 6.84161 7.68735 6.91957 7.75302 6.98523C7.81868 7.05089 7.89664 7.10298 7.98243 7.13851C8.06823 7.17404 8.16019 7.19232 8.25305 7.19231C8.34591 7.19229 8.43787 7.21057 8.52366 7.2461C8.60946 7.28163 8.68742 7.33372 8.75308 7.39938C8.81874 7.46504 8.87083 7.543 8.90636 7.6288C8.94189 7.71459 8.96017 7.80655 8.96015 7.89941L8.96015 13.849C8.96019 14.1142 8.85489 14.3686 8.66741 14.5561L6.42447 16.7991C6.23699 16.9866 6.13169 17.241 6.13173 17.5062L6.13173 18.2133C6.13177 18.4784 6.23712 18.7327 6.42462 18.9202C6.61212 19.1077 6.86641 19.2131 7.13158 19.2131L17.8598 19.2131C18.125 19.2131 18.3793 19.1077 18.5668 18.9202C18.7543 18.7327 18.8596 18.4784 18.8596 18.2133V17.5062C18.8597 17.241 18.7544 16.9866 18.5669 16.7991L16.3247 14.5568C16.1372 14.3693 16.0319 14.1149 16.0319 13.8497L16.0319 7.90012C16.0318 7.80726 16.05 7.71528 16.0855 7.62945C16.1209 7.54362 16.1729 7.46561 16.2385 7.39988C16.3041 7.33415 16.382 7.28199 16.4678 7.24637C16.5535 7.21076 16.6455 7.19238 16.7383 7.19231Z" fill={isPinned ? '#556484' : 'none'} stroke="#556484" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
            </div>

            <div className="enterprise-card__body">
                <div className="enterprise-card__metrics-row">
                    <Metric value={locationsWithCriticalEvents} total={locationsTotal} label="Locations w/ Critical Events" />
                    <Metric value={locationsOffline} total={locationsTotal} label="Locations Offline" />
                </div>

                <div className="enterprise-card__offline-devices">
                    <div className="enterprise-card__offline-label">Offline Devices</div>
                    <div className="enterprise-card__device-row">
                        <span className={`enterprise-card__device-count ${gatewaysOffline > 0 ? 'is-alert' : ''}`}>
                            {gatewaysOffline}/{gatewaysTotal}
                        </span>
                        {' '}<span className={`enterprise-card__device-label ${gatewaysOffline > 0 ? 'is-alert' : ''}`}>Gateways</span>
                    </div>
                    <div
                        className="enterprise-card__device-row enterprise-card__device-row--sensors"
                        onMouseEnter={handleProtocolEnter}
                        onMouseLeave={handleProtocolLeave}
                    >
                        <span className={`enterprise-card__device-count ${(timeframe !== null ? sensorsOfflineInWindow : sensorsOffline) > 0 ? 'is-alert' : ''}`}>
                            {timeframe !== null ? sensorsOfflineInWindow : sensorsOffline}/{sensorsTotal}
                        </span>
                        {' '}<span className={`enterprise-card__device-label ${(timeframe !== null ? sensorsOfflineInWindow : sensorsOffline) > 0 ? 'is-alert' : ''}`}>Sensors</span>
                        {timeframe !== null && (
                            <div className="enterprise-card__sensor-window-label">
                                {sensorsOffline} sensors offline (all time)
                            </div>
                        )}
                        {showProtocolPopover && breakdown.length > 0 && (
                            <ProtocolPopover breakdown={breakdown} />
                        )}
                    </div>
                </div>

                <div className="enterprise-card__footer">
                    {(() => {
                        const isAlert = locationsTotal > 0 && locationsWithAlertsDisabled === locationsTotal;
                        return <span className="enterprise-card__footer-text">
                            <span className={`enterprise-card__footer-count ${isAlert ? 'is-alert' : ''}`}>
                                {locationsWithAlertsDisabled}/{locationsTotal}
                            </span>
                            {' '}<span className={`enterprise-card__footer-label ${isAlert ? 'is-alert' : ''}`}>Locations w/ Alerts Disabled</span>
                        </span>;
                    })()}
                    <span className="enterprise-card__protocols">
                        {protocolTypes.map(p => {
                            const meta = PROTOCOL_META[p];
                            return meta ? <span key={p} title={meta.label}><meta.Icon /></span> : null;
                        })}
                    </span>
                </div>
            </div>
        </div>
    );
};

export { TIMEFRAME_OPTIONS, SORT_OPTIONS };
export default EnterpriseCard;
